import React, { useState } from 'react';

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    website_url: '' // Honeypot field
  });
  const [status, setStatus] = useState({ type: null, message: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: null, message: '' });

    try {
      const response = await fetch('https://api.dev.auxo.dk/webform/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          website_url: formData.website_url // Must be included
        })
      });

      const data = await response.json();

      if (response.ok && data.status === 'ok') {
        setStatus({
          type: 'success',
          message: 'Tak for din besked! Vi vender tilbage til dig hurtigst muligt.'
        });
        setFormData({ name: '', email: '', subject: '', message: '', website_url: '' });
      } else {
        setStatus({
          type: 'error',
          message: data.message || 'Der skete en fejl under afsendelsen. Prøv venligst igen senere.'
        });
      }
    } catch (error) {
      setStatus({
        type: 'error',
        message: 'Netværksfejl. Kontroller venligst din internetforbindelse og prøv igen.'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm">
      <h3 className="font-serif text-2xl font-bold text-secondary mb-6">Send os en besked</h3>

      {status.type && (
        <div
          className={`mb-6 p-4 rounded-xl text-sm font-medium ${
            status.type === 'success'
              ? 'bg-emerald-50 text-emerald-800 border border-emerald-100'
              : 'bg-rose-50 text-rose-800 border border-rose-100'
          }`}
        >
          <div className="flex items-center gap-2">
            <i className={`fa-solid ${status.type === 'success' ? 'fa-circle-check text-emerald-500' : 'fa-circle-exclamation text-rose-500'}`} />
            <span>{status.message}</span>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Honeypot field - ABSOLUTELY HIDDEN from humans */}
        <div className="sr-only absolute -z-50 pointer-events-none" aria-hidden="true">
          <label htmlFor="website_url">Lad dette felt være tomt</label>
          <input
            type="text"
            id="website_url"
            name="website_url"
            value={formData.website_url}
            onChange={handleChange}
            tabIndex="-1"
            autoComplete="off"
          />
        </div>

        <div>
          <label htmlFor="name" className="block text-sm font-semibold text-slate-700 mb-1.5">
            Dit navn <span className="text-rose-500">*</span>
          </label>
          <input
            type="text"
            id="name"
            name="name"
            required
            value={formData.name}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-primary focus:ring-2 focus:ring-teal-100 outline-none transition-all text-sm"
            placeholder="Indtast dit fulde navn"
          />
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-semibold text-slate-700 mb-1.5">
            Din e-mail-adresse <span className="text-rose-500">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            required
            value={formData.email}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-primary focus:ring-2 focus:ring-teal-100 outline-none transition-all text-sm"
            placeholder="eksempel@domæne.dk"
          />
        </div>

        <div>
          <label htmlFor="subject" className="block text-sm font-semibold text-slate-700 mb-1.5">
            Emne <span className="text-rose-500">*</span>
          </label>
          <input
            type="text"
            id="subject"
            name="subject"
            required
            value={formData.subject}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-primary focus:ring-2 focus:ring-teal-100 outline-none transition-all text-sm"
            placeholder="Hvad drejer din henvendelse sig om?"
          />
        </div>

        <div>
          <label htmlFor="message" className="block text-sm font-semibold text-slate-700 mb-1.5">
            Meddelelse <span className="text-rose-500">*</span>
          </label>
          <textarea
            id="message"
            name="message"
            required
            rows="5"
            value={formData.message}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-primary focus:ring-2 focus:ring-teal-100 outline-none transition-all text-sm resize-none"
            placeholder="Skriv din besked her..."
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3.5 px-6 rounded-full text-white bg-primary hover:bg-primary-dark font-semibold shadow-md hover:shadow-lg transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? (
            <>
              <i className="fa-solid fa-spinner animate-spin" />
              <span>Sender...</span>
            </>
          ) : (
            <>
              <i className="fa-regular fa-paper-plane" />
              <span>Send meddelelse</span>
            </>
          )}
        </button>
      </form>
    </div>
  );
}
